import { useState, useEffect } from "react";
import { Viewer, Worker } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";

import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";

const PDFViewer = ({ pdfUrl, base64Data, height = "500px" }) => {
  const layoutPlugin = defaultLayoutPlugin();
  const [blobUrl, setBlobUrl] = useState(null);

  useEffect(() => {
    if (base64Data) {
      try {
        // Convert base64 to Blob URL
        const byteChars = atob(base64Data);
        const byteNumbers = new Array(byteChars.length);
        for (let i = 0; i < byteChars.length; i++) {
          byteNumbers[i] = byteChars.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);
        setBlobUrl(url);

        // Cleanup
        return () => URL.revokeObjectURL(url);
      } catch (e) {
        console.error("Error decoding base64:", e);
        setBlobUrl(null);
      }
    } else if (pdfUrl) {
      setBlobUrl(pdfUrl);
    }
  }, [base64Data, pdfUrl]);

  if (!blobUrl) return <p>Loading PDF...</p>;

  return (
    <div style={{ height, border: "1px solid #ddd" }}>
      <Worker workerUrl="https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js">
        <Viewer fileUrl={blobUrl} plugins={[layoutPlugin]} />
      </Worker>
    </div>
  );
};

export default PDFViewer;